import React from "react";
import { default as MUISelect } from "@mui/material/Select";
import styled from "styled-components";

const getWidth = ({ fullWidth, autoWidth, width }) => {
  if (autoWidth) return "auto";
  if (fullWidth) return "100%";
  if (width) return width;
  return "300px";
};

const StyledMUISelect = styled(MUISelect)`
  height: 50px;
  border-radius: 8px !important;
  width: ${({ fullWidth, autoWidth, width }) =>
    getWidth({ fullWidth, autoWidth, width })} !important;
  min-width: ${({ minwidth }) => minwidth || "none"};
  max-width: ${({ maxWidth }) => maxWidth || "none"};
  background-color: #fff;
  font-family: var(--primaryTextFont) !important;

  &:not(.Mui-disabled) fieldset {
    background: unset;
    box-shadow: unset;
    border: 1px solid var(--colorBorder) !important;
  }

  &.Mui-focused fieldset {
    border: 2px solid var(--primaryColor) !important;
  }

  .MuiSelect-select,
  .MuiNativeSelect-select {
    font-size: 14px;
  }

  &:hover:not(.Mui-disabled):not(.Mui-focused) fieldset {
    border: 2px solid var(--colorBorder) !important;
  }
`;

export const Select = (props) => {
  return <StyledMUISelect {...props} MenuProps={{ disableScrollLock: true }} />;
};
